import { format } from 'date-fns'
import QueryString from 'qs'
import React, { MouseEvent, useCallback, useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useLocation, useNavigate } from 'react-router-dom'
import { MarketingConsentModalProps, OpenEventProps, ProfileRootType } from '../../@types/auth'
import { getProfile, postOpenid } from '../../api/auth'
import { getUserNotiSetting, getWelcome, postUserNotiSetting } from '../../api/login'
import DebounceButton from '../../components/btn/DebouceButton'
import CommentEventModal from '../../components/event/CommonEventModal'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import '../../css/Event.css'
import { handlePostMessage, RNPostMessage, AFWebLinkType } from '../../js/postMessage'
import { imgURL } from '../Home'

const SignUpModal = () => {
  return (
    <>
      <div>
        <div className='modal-title'>
          이미 회원가입을
          <br />
          완료 하셨습니다.
        </div>
        <div className='modal-container'>
          회원가입 30000 적립금 지급이 이미 완료되었습니다.
          <br />첫 마케팅 동의를 해주시면 5일마다 적립금 1,000원씩을 드립니다.
        </div>
      </div>
    </>
  )
}

const MarketingConsentModal = ({ advertiseAgreeDate }: MarketingConsentModalProps) => {
  return (
    <>
      {!advertiseAgreeDate ? (
        <div>
          <div className='modal-title'>마케팅 활용에 동의해주세요.</div>
          <div className='modal-container'>마케팅 활용 동의를 하시면 5일마다 적립금 1,000원씩을 드립니다.</div>
        </div>
      ) : (
        <div>
          <div className='modal-title'>이미 마케팅 동의가 완료되었습니다.</div>
          <div className='modal-container'>5일마다 적립금을 발급드립니다. 발급될 때 푸쉬알림으로 알려드립니다.</div>
        </div>
      )}
      <div></div>
    </>
  )
}

// const OneHundredWonShopModal = () => {
//   return (
//     <>
//       <div>
//         <div className="modal-title">100원 샵으로 이동할 수 없습니다</div>
//         <div className="modal-container">
//           기존 구매이력이 있습니다. 구매하신 상품을 아직 구매확정 하지 않으셨다면 구매확정 하셔서 페이백을 받아주세요.
//         </div>
//       </div>
//     </>
//   );
// };

const MobileOpenEvent: React.FC<OpenEventProps> = ({
  notificationHandler,
  userData,
  advertiseAgreeDate,
  isAgreeForMarketing,
  isOpenModal,
  setIsOpenModal,
  modalType,
}) => {
  const [clickedButton, setClickedButton] = useState<string | null>(null)

  const imageButtonHandler = (buttonId: string) => {
    setClickedButton(buttonId)
    setTimeout(() => {
      setClickedButton(null)
    }, 200)
  }

  const marketingModalHandler = async () => {
    const notAgreeForAd = Boolean(!isAgreeForMarketing && !advertiseAgreeDate && userData)
    if (notAgreeForAd && userData) {
      try {
        const agreeNotification = await postUserNotiSetting(true)
        const isAgreeComplete = agreeNotification.data.message === 'ok'
        if (isAgreeComplete) alert('마케팅 동의가 완료되어 5일뒤 적립금이 발급됩니다.')
      } catch (error) {
        console.error(error)
      }
    }
    setIsOpenModal(false)
  }

  return (
    <>
      <div className='open_event'>
        <div className='open_event_img'>
          <img src={`${imgURL}/open_event_0220/mo/subtop.jpg`} alt='신규회원 누구나 웰컴 3만원 이상 쿠폰팩' />

          <img
            src={`${imgURL}/open_event/mo/sub1.jpg`}
            alt='가입만 해도 이걸 다? 회원 가입만 하셔도 적립금, 쿠폰, 페이백을 모두 드립니다.'
          />

          {/* 회원가입 적립금 */}
          <img
            src={`${imgURL}/open_event_0220/mo/sub2.jpg`}
            style={{ marginBottom: '26px' }}
            alt='step1 회원가입 적립금'
          />
          <DebounceButton
            style={{
              display: 'block',
              width: '100%',
              cursor: 'pointer',
              border: 'none',
            }}
            waitMS={200}
            onClick={(e) => notificationHandler(e, 'signUp')}
          >
            <img
              src={`${imgURL}/open_event/mo/sub_bt_joinmembers.jpg`}
              alt='회원가입 바로하기 버튼'
              style={{
                mixBlendMode: clickedButton === 'signUp' ? 'overlay' : 'normal',
              }}
              onClick={() => imageButtonHandler('signUp')}
            />
          </DebounceButton>

          {/* 마케팅 수신동의 적립금 */}
          <img src={`${imgURL}/open_event_0220/mo/sub3.jpg`} alt='step2 마케팅 수신동의 적립금' />
          <DebounceButton
            style={{
              display: 'block',
              width: '100%',
              cursor: 'pointer',
              border: 'none',
            }}
            waitMS={200}
            onClick={(e) => notificationHandler(e, 'marketingConsent')}
          >
            <img
              src={`${imgURL}/open_event/mo/sub_bt_marketing.jpg`}
              alt='마케팅 수신 동의 버튼'
              style={{
                mixBlendMode: clickedButton === 'marketingConsent' ? 'overlay' : 'normal',
              }}
              onClick={() => imageButtonHandler('marketingConsent')}
            />
          </DebounceButton>

          {/* 페이백 */}
          <img src={`${imgURL}/open_event/mo/sub4.jpg`} alt='step3 구매확정 후 페이백' />

          {/* 쇼핑하러 가기 */}
          <DebounceButton
            style={{
              display: 'block',
              width: '100%',
              cursor: 'pointer',
              border: 'none',
              boxSizing: 'border-box',
              marginBottom: '80px',
              backgroundColor: '#fff',
            }}
            waitMS={200}
            onClick={(e) => notificationHandler(e, 'goToShop')}
          >
            <img src={`${imgURL}/open_event/mo/sub_bt_shopping.jpg`} alt='쇼핑하러 가기 버튼' />
          </DebounceButton>

          {isOpenModal && (
            <CommentEventModal
              isOpenModal={isOpenModal}
              setIsOpenModal={setIsOpenModal}
              bodyChildren={
                <>
                  {modalType === 'signUp' && <SignUpModal />}
                  {modalType === 'marketingConsent' && (
                    <MarketingConsentModal advertiseAgreeDate={advertiseAgreeDate} />
                  )}
                  {/* {modalType === 'oneHundredWonShop' && <OneHundredWonShopModal />} */}
                </>
              }
              footerChildren={
                <>
                  {modalType === 'signUp' && <button onClick={() => setIsOpenModal(false)}>확인</button>}
                  {modalType === 'marketingConsent' && (
                    <button onClick={marketingModalHandler}>{isAgreeForMarketing ? '확인' : '마케팅 동의 하기'}</button>
                  )}
                  {/* {modalType === 'oneHundredWonShop' && <button onClick={() => setIsOpenModal(false)}>확인</button>} */}
                </>
              }
            />
          )}
        </div>
      </div>
    </>
  )
}

const DesktopOpenEvent: React.FC<OpenEventProps> = ({
  notificationHandler,
  userData,
  advertiseAgreeDate,
  isAgreeForMarketing,
  isOpenModal,
  setIsOpenModal,
  modalType,
}) => {
  const [clickedButton, setClickedButton] = useState<string | null>(null)

  const imageButtonHandler = (buttonId: string) => {
    setClickedButton(buttonId)
    setTimeout(() => {
      setClickedButton(null)
    }, 200)
  }

  const marketingModalHandler = async () => {
    const notAgreeForAd = Boolean(!isAgreeForMarketing && !advertiseAgreeDate && userData)
    if (notAgreeForAd && userData) {
      try {
        const agreeNotification = await postUserNotiSetting(true)
        const isAgreeComplete = agreeNotification.data.message === 'ok'
        if (isAgreeComplete) alert('마케팅 동의가 완료되어 5일뒤 적립금이 발급됩니다.')
      } catch (error) {
        console.error(error)
      }
    }
    setIsOpenModal(false)
  }

  return (
    <>
      <div className='open_event'>
        <div
          className='open_event_img'
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            src={`${imgURL}/open_event_0220/pc/subtop.jpg`}
            style={{ width: '100vw' }}
            alt='신규회원 누구나 웰컴 3만원 이상 쿠폰팩'
          />
          <img
            src={`${imgURL}/open_event_0220/pc/sub1.jpg`}
            alt='가입만 해도 이걸 다? 회원 가입만 하셔도 적립금, 쿠폰, 페이백을 모두 드립니다.'
          />
          <div
            style={{
              display: 'flex',
              width: '77.8%',
              justifyContent: 'center',
            }}
          >
            {/* 회원가입 적립금 */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flexBasis: '50%',
                border: 'none',
                boxSizing: 'border-box',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#fff',
              }}
            >
              <img src={`${imgURL}/open_event/pc/sub2.jpg`} alt='step1 회원가입 적립금' />
              <DebounceButton
                style={{
                  display: 'block',
                  width: '100%',
                  cursor: 'pointer',
                  border: 'none',
                }}
                waitMS={200}
                onClick={(e) => notificationHandler(e, 'signUp')}
              >
                <img
                  src={`${imgURL}/open_event/pc/sub_bt_joinmembers.jpg`}
                  alt='회원가입 바로하기 버튼'
                  style={{ mixBlendMode: clickedButton === 'signUp' ? 'overlay' : 'normal' }}
                  onClick={() => imageButtonHandler('signUp')}
                />
              </DebounceButton>
            </div>

            {/* 마케팅 동의 */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flexBasis: '50%',
                border: 'none',
                boxSizing: 'border-box',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#fff',
              }}
            >
              <img src={`${imgURL}/open_event_0220/pc/sub3.jpg`} alt='step2 마케팅 수신동의 적립금' />
              <DebounceButton
                style={{
                  display: 'block',
                  width: '100%',
                  cursor: 'pointer',
                  border: 'none',
                }}
                waitMS={200}
                onClick={(e) => notificationHandler(e, 'marketingConsent')}
              >
                <img
                  src={`${imgURL}/open_event/pc/sub_bt_marketing.jpg`}
                  alt='마케팅 수신 동의 버튼'
                  style={{
                    mixBlendMode: clickedButton === 'marketingConsent' ? 'overlay' : 'normal',
                  }}
                  onClick={() => imageButtonHandler('marketingConsent')}
                />
              </DebounceButton>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              width: '77.8%',
              justifyContent: 'center',
            }}
          >
            {/* 페이백 */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flexBasis: '50%',
                border: 'none',
                boxSizing: 'border-box',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img src={`${imgURL}/open_event/pc/sub4.jpg`} alt='step4 구매확정 후 페이백' />
            </div>

            {/* 100원 샵 */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flexBasis: '50%',
                border: 'none',
                boxSizing: 'border-box',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#fff',
              }}
            >
              <img src={`${imgURL}/open_event/pc/sub5.jpg`} alt='step5 어피페이 등록 후 결제' />
            </div>
          </div>
          <DebounceButton
            style={{
              display: 'block',
              width: '100%',
              cursor: 'pointer',
              border: 'none',
              boxSizing: 'border-box',
              marginBottom: '80px',
              backgroundColor: '#fff',
            }}
            waitMS={200}
            onClick={(e) => notificationHandler(e, 'goToShop')}
          >
            <img src={`${imgURL}/events/pc/sub_bt_shopping-min.jpg`} alt='쇼핑하러 가기 버튼' />
          </DebounceButton>

          {isOpenModal && (
            <CommentEventModal
              isOpenModal={isOpenModal}
              setIsOpenModal={setIsOpenModal}
              bodyChildren={
                <>
                  {modalType === 'signUp' && <SignUpModal />}
                  {modalType === 'marketingConsent' && (
                    <MarketingConsentModal advertiseAgreeDate={advertiseAgreeDate} />
                  )}
                  {/* {modalType === 'oneHundredWonShop' && <OneHundredWonShopModal />} */}
                </>
              }
              footerChildren={
                <>
                  {modalType === 'signUp' && <button onClick={() => setIsOpenModal(false)}>확인</button>}
                  {modalType === 'marketingConsent' && (
                    <button onClick={marketingModalHandler}>{isAgreeForMarketing ? '확인' : '마케팅 동의 하기'}</button>
                  )}
                  {/* {modalType === 'oneHundredWonShop' && <button onClick={() => setIsOpenModal(false)}>확인</button>} */}
                </>
              }
            />
          )}
        </div>
      </div>
    </>
  )
}

export default function OpenEvent() {
  const navigate = useNavigate()
  const location = useLocation()
  const { setDirect, isAppView } = useAppContext()
  const { setIsLogin, hasAccessToken } = useCommonContext()
  const [userData, setUserData] = useState<ProfileRootType | null>(null)
  const [locationText, setLocationText] = useState<any>('')
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
  const [modalType, setModalType] = useState<string>('')
  const [isAgreeForMarketing, setIsAgreeForMarketing] = useState<boolean>(false)
  const [advertiseAgreeDate, setAdvertiseAgreeDate] = useState<string | undefined>()

  const handleAppNavigation = async (accessToken: boolean, type?: string) => {
    switch (type) {
      case 'signUp':
        if (hasAccessToken) {
          setModalType('signUp')
          // 회원가입 적립금 조회
          const response = await getWelcome()
          const message = response.data.message
          if (message === 'ok') setIsOpenModal(true)
        } else {
          if (isAppView) {
            handlePostMessage({ actionType: 'onSignInInducement' })
          } else {
            setIsLogin(true)
          }
        }
        break
      case 'marketingConsent':
        if (hasAccessToken && userData) {
          setModalType('marketingConsent')
          // 유저 알림 정보 조회
          const userNotification = await getUserNotiSetting()
          if (userNotification.data.advertisingConsentDate && userNotification.data.isMarketing) {
            const newDate = new Date(userNotification.data.advertisingConsentDate)
            const formattedDate = format(newDate, 'yyyy-MM-dd')
            setAdvertiseAgreeDate(formattedDate)
            setIsAgreeForMarketing(true)
          }
          setIsOpenModal(true)
        } else {
          if (isAppView) {
            handlePostMessage({ actionType: 'onSignInInducement' })
          } else {
            setIsLogin(true)
          }
        }
        break
      // case 'oneHundredWonShop':
      //   if (hasAccessToken) {
      //     setModalType('oneHundredWonShop');
      //     const response = await getOrderList();
      //     if (response.data.totalCount > 0) {
      //       setIsOpenModal(true);
      //     } else {
      //       if (app) {
      //         const url = `aboutfishing://aboutfishing.com/?page=shop-main&url=${process.env.REACT_APP_SHOP_URL}/100wonshop`;
      //         handlePostMessage({ actionType: 'moveToLink', params: { url } });
      //       } else {
      //         navigate('/100wonshop');
      //       }
      //     }
      //   } else {
      //     if (app) {
      //       handlePostMessage({ actionType: 'onSignInInducement' });
      //     } else {
      //       setIsLogin(true);
      //     }
      //   }
      //   break;
      case 'goToShop':
        if (isAppView) {
          RNPostMessage(AFWebLinkType.moveToLink, {
            url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}`,
          })
        } else {
          navigate('/')
        }
        break
      default:
        break
    }
  }

  // const handleMarketingNotification = async () => {
  //   const response = await getUserNoti()
  //   if (!response || !userData) return
  //   const marketingRes = await getMarketingAgreeAcc(userData.memberNo)
  //   if (marketingRes.data.message === 'ok') {
  //     if (hasAccessToken) {
  //       setIsToast(true)
  //       setToastMessage('이미 회원가입을 완료하였습니다.')
  //     }
  //   }
  // }

  const notificationHandler = useCallback(
    (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent> | undefined, type?: string) => {
      e?.preventDefault()
      // const aboutAccessToken = getParsedLocalStorageItem('aboutAccessToken')

      // if (aboutAccessToken) handleMarketingNotification()
      if (type) return handleAppNavigation(hasAccessToken, type)
    },
    [userData, hasAccessToken]
  )

  const handleProfile = async () => {
    if (hasAccessToken) {
      const response = await getProfile()
      setUserData(response.data)
    }
  }

  const handleDirect = () => {
    setDirect(window.history.state.idx <= 1)
  }

  // FIXME: 해당 소스 리팩토링 하긴 하였으나 사용용처가 정확하지 않음
  // 사용 용처 확인 후 사용되지 않는다면 삭제 필요. handleToken 함수 분기처리에 추가 수정이 필요
  const handleLocationText = () => {
    const query = QueryString.parse(location.search, {
      ignoreQueryPrefix: true,
    })
    setLocationText(query)
    if (query.app === 'true') window.sessionStorage.setItem('app', JSON.stringify(true))
  }

  const handleToken = async () => {
    if (!locationText || !locationText?.token) return
    const response = await postOpenid(locationText.token)
    window.localStorage.setItem('accessToken', JSON.stringify(response.data.accessToken))
    window.localStorage.setItem('aboutAccessToken', JSON.stringify(locationText.token))

    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/openevent`,
      })
    } else {
      navigate('/openevent')
    }
    window.location.reload()
  }

  useEffect(() => {
    handleProfile()
  }, [hasAccessToken])

  useEffect(() => {
    handleDirect()
    handleLocationText()
  }, [location])

  useEffect(() => {
    handleToken()
  }, [locationText])

  return (
    <>
      <div className='main_wrap' style={{ overflowX: 'hidden' }}>
        <div className='contents_wrap'>
          {isMobile ? (
            <MobileOpenEvent
              notificationHandler={notificationHandler}
              userData={userData}
              advertiseAgreeDate={advertiseAgreeDate}
              isAgreeForMarketing={isAgreeForMarketing}
              isOpenModal={isOpenModal}
              setIsOpenModal={setIsOpenModal}
              modalType={modalType}
            />
          ) : (
            <DesktopOpenEvent
              notificationHandler={notificationHandler}
              userData={userData}
              advertiseAgreeDate={advertiseAgreeDate}
              isAgreeForMarketing={isAgreeForMarketing}
              isOpenModal={isOpenModal}
              setIsOpenModal={setIsOpenModal}
              modalType={modalType}
            />
          )}
        </div>
      </div>
    </>
  )
}
